import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FuluDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-orange-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fulu')}
            className="flex items-center text-amber-800 mb-8 hover:text-amber-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符箓列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-amber-200 overflow-hidden">
            <div className="bg-gradient-to-r from-amber-500 to-orange-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                求 财 符 箓
              </h1>
              <p className="text-white/80 mt-2">财运亨通，生意兴隆</p>
            </div>

            <div className="p-8">
              <div className="flex justify-center mb-8">
                <img
                  src="/images/fulu/fulu_qiucai1.png"
                  alt="求财符箓"
                  className="max-w-md rounded-lg shadow-lg"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>

              <div className="space-y-6 text-gray-700 leading-relaxed">
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-100">
                  <h3 className="text-lg font-bold text-amber-900 mb-3">符箓说明</h3>
                  <p>此符为求财符箓，需诚心供奉，每日早晚焚香叩拜，默念心中所求之事。</p>
                </div>

                <div className="bg-amber-50 rounded-xl p-6 border border-amber-100">
                  <h3 className="text-lg font-bold text-amber-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2">
                    <li>选择吉日吉时焚香请符</li>
                    <li>将符箓供奉于财神位或客厅东北方</li>
                    <li>每日诚心叩拜，默念所求</li>
                    <li>心诚则灵，需保持善念</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuluDetail;
